// Lib
import React, { MutableRefObject } from 'react';
import { useSelector } from 'react-redux';
import { getIsFeatureEnabledForCurrentUser } from '../feature/elementFeatureSelector';
import Handsontable from 'handsontable';
import HotTable from './HotTable';
import LegacyHotTable from './legacy/HotTable';
import { TranslationFunction } from '../../components/i18n/types';
import { ExperimentId } from '../../../common/experiments/experimentsConstants';
import { registerHotPlugins } from './hotPluginsRegistration';

import './HotTableSwitch.scss';

// Register the plugins once globally
// TODO-TABLES - This can be moved to HotTable when the legacy implementation is removed
registerHotPlugins();

type HotTableSwitchProps = {
    hotTableInstanceRef: MutableRefObject<Handsontable | null>;
    showTitle: boolean;
    showCaption: boolean;
    isReadOnly: boolean;
    isGridMoving: boolean;
    setIsGridMoving: (isMoving: boolean) => void;
    translateTableContextMenu: TranslationFunction;
};

const HotTableSwitch: React.FC<HotTableSwitchProps> = (props) => {
    const isTableDataV2Enabled = useSelector(getIsFeatureEnabledForCurrentUser(ExperimentId.tableArchV2));

    if (isTableDataV2Enabled) {
        return <HotTable {...props} />;
    }

    return <LegacyHotTable {...props} />;
};

export default HotTableSwitch;
